import { EVENTS } from '../../../bus/events.const';
import { COMPONENTS } from '../../../components/components.registry';
import { EmpathizeConfig } from '../../../models';
import { GETTERS_KEYS } from '../../../store';

export const DEFAULT_EMPATHIZE_LAYOUT_CONFIG = {
  queryHistory: {
    component: COMPONENTS.SMART.History,
    getter: GETTERS_KEYS.history.queryHistory,
    itemSelectedEvent: EVENTS.QueryHistoryTermSelected,
    showWhenEmpty: false
  },
  popularSearches: {
    component: COMPONENTS.SMART.PopularSearches,
    getter: GETTERS_KEYS.empathize.popularSearches,
    itemSelectedEvent: EVENTS.PopularSearchSelected,
    showWhenEmpty: false
  },
  suggestions: {
    component: COMPONENTS.SMART.Suggestions,
    getter: GETTERS_KEYS.empathize.termSuggestions,
    itemSelectedEvent: EVENTS.SuggestionSelected,
    showWhenEmpty: false
  },
  nextQueriesSuggestions: {
    component: COMPONENTS.SMART.NextQueriesSuggestions,
    getter: GETTERS_KEYS.empathize.nextQueriesSuggestions,
    itemSelectedEvent: EVENTS.NextQuerySuggestionSelected,
    showWhenEmpty: false
  },
  resultsSuggestions: {
    component: COMPONENTS.SMART.ResultsSuggestions,
    getter: GETTERS_KEYS.empathize.resultsSuggestions,
    itemSelectedEvent: EVENTS.ResultClicked,
    showWhenEmpty: false
  },
  identifierSuggestions: {
    component: COMPONENTS.SMART.IdentifierSuggestions,
    getter: GETTERS_KEYS.empathize.identifierSuggestions,
    itemSelectedEvent: EVENTS.ResultClicked,
    showWhenEmpty: false
  },
  redirectionsSuggestions: {
    component: COMPONENTS.SMART.RedirectionsSuggestions,
    getter: GETTERS_KEYS.empathize.redirectionsSuggestions,
    itemSelectedEvent: EVENTS.RedirectionClicked,
    showWhenEmpty: false
  }
};

export const DEFAULT_EMPATHIZE_CONFIG: EmpathizeConfig = {
  components: {
    panel: COMPONENTS.PANELS.FullScreenEmpathizePanel,
    extra: []
  },
  debounceTimeInMs: 200,
  searchBoxSelector: '',
  minQueryLength: 1,
  layout: {
    noQuery: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.queryHistory],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.popularSearches],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.nextQueriesSuggestions]
    ],
    query: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.suggestions],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.nextQueriesSuggestions],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.identifierSuggestions]
    ],
    identifierSearch: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.identifierSuggestions]
    ]
  }
};
